import { render, staticRenderFns } from "./impacta-mas-bonus-table.vue?vue&type=template&id=642e09e7&scoped=true&"
import script from "./impacta-mas-bonus-table.vue?vue&type=script&lang=js&"
export * from "./impacta-mas-bonus-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e09e7",
  null
  
)

export default component.exports